import { JsonView, collapseAllNested, darkStyles, defaultStyles } from "react-json-view-lite";
import "react-json-view-lite/dist/index.css";
import { useTheme } from "shared/contexts/ThemeContext";

import { Button, Flexbox, Icons, Sentiments } from "@sede-x/shell-ds-react-framework";
import { TMovement } from "ticketing/ticketing.types";

const removeTypeNameFromGQLResult = (result: Record<string, unknown>) => {
  return JSON.parse(
    JSON.stringify(result, (key, value) => {
      if (key === "__typename") {
        return undefined;
      }
      return value;
    })
  );
};

export const MovementDebugInfo = ({
  movement,
  onClose
}: {
  movement: TMovement;
  onClose: () => void;
}) => {
  const { theme } = useTheme();
  const copyContent = () => {
    navigator.clipboard.writeText(JSON.stringify(movement, null, 2));
  };

  const customStyles = {
    ...(theme === "light" ? defaultStyles : darkStyles),
    container: "movement-degug-info",
    basicChildStyle: "basic-element-style"
  };
  return (
    <Flexbox
      flexDirection="column"
      style={{
        width: "100%",
        maxHeight: "minmax(296px, 100%)"
      }}>
      <Flexbox
        justifyContent="space-between"
        alignItems="center"
        style={{
          backgroundColor: "var(--nav-selected-bg)"
        }}>
        <Button
          onClick={copyContent}
          iconOnly={true}
          icon={<Icons.CopyFile style={{ fill: "green" }} />}
          size="xsmall"
          style={{
            width: "40px",
            minWidth: "unset",
            background: "transparent"
          }}
        />
        <Button
          onClick={onClose}
          sentiment={Sentiments.Negative}
          icon={<Icons.Cross />}
          size="small">
          Close
        </Button>
      </Flexbox>
      <div
        style={{
          width: "100%",
          maxHeight: "500px",
          overflowY: "auto",
          overflowX: "auto"
        }}>
        <JsonView
          data={removeTypeNameFromGQLResult(movement)}
          shouldExpandNode={collapseAllNested}
          style={customStyles}
          clickToExpandNode={true}
        />
      </div>
    </Flexbox>
  );
};
